import { actionTypes } from '../types/actionTypes'
import { ReducerCheckState } from '../types/reducerTypes'

/*
Copyright 2022-07-25 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan reducer para sku y ubicación
*/

export const initialState: ReducerCheckState = {
  searchedId: '',
  isWorkOrderId: true,
  workOrderSearchCheckInOut: undefined,
  workOrder: undefined,
  error: undefined,
  loading: false,
  wasRegistered: false,
  driver: '',
  showCheckInDescription: false,
  showCheckOutDescription: false,
  showModal: false,
  search: undefined,
  workOrderDispatcher: '',
  checkInWorkOrder: undefined,
  isPickingStatus: false,
  zonesStatus: [],
  loadingZones: false
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const checkReducer = (state: ReducerCheckState, action: actionTypes) => {
  switch (action.type) {
    case 'setSearchedId':
      return {
        ...state,
        searchedId: action.payload
      }
    case 'setIsWorkOrderId':
      return {
        ...state,
        isWorkOrderId: action.payload
      }
    case 'setWorkOrderSearchCheckInOut':
      return {
        ...state,
        workOrderSearchCheckInOut: action.payload
      }
    case 'setWorkOrder':
      return {
        ...state,
        workOrder: action.payload
      }
    case 'setError':
      return {
        ...state,
        error: action.payload
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.payload
      }
    case 'setWasRegistered':
      return {
        ...state,
        wasRegistered: action.payload
      }
    case 'setDriver':
      return {
        ...state,
        driver: action.payload
      }
    case 'setShowCheckInDescription':
      return {
        ...state,
        showCheckInDescription: action.payload
      }
    case 'setShowModal':
      return {
        ...state,
        showModal: action.payload
      }
    case 'setSearch':
      return {
        ...state,
        search: action.payload
      }
    case 'setWorkOrderDispatcher':
      return {
        ...state,
        workOrderDispatcher: action.payload
      }
    case 'setCheckInWorkOrder':
      return {
        ...state,
        checkInWorkOrder: action.payload
      }
    case 'setShowPickingRouteStatus':
      return {
        ...state,
        isPickingStatus: action.payload
      }
    case 'setZonesStatus':
      return {
        ...state,
        zonesStatus: action.payload
      }
    case 'setLoadingZones':
      return {
        ...state,
        loadingZones: action.payload
      }
    // case '':
    // return {
    //   ...state,
    //   : action.payload
    // }
    default:
      return state
  }
}
